import { useQuery } from '@tanstack/react-query';
import { getResourceFolders } from '../api/resources.member.api';
import { resourcesKeys } from './resources.keys';

/**
 * Active (non-retired) resource folders for the member landing page.
 */
export function useResourceFolders() {
  return useQuery({
    queryKey: resourcesKeys.folders(),
    queryFn: getResourceFolders,
  });
}
